import { CreditCard } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Card network badge.
 *
 * Wordmarks are deliberately text rather than logo files: the networks
 * license their marks, and a plain label carries the same information.
 */
const BRAND_STYLES: Record<string, { label: string; className: string }> = {
  visa: { label: 'VISA', className: 'bg-[#1434CB] text-white tracking-wider' },
  mastercard: { label: 'MC', className: 'bg-[#EB001B] text-white' },
  amex: { label: 'AMEX', className: 'bg-[#006FCF] text-white' },
  discover: { label: 'DISC', className: 'bg-[#FF6000] text-white' },
  diners: { label: 'DC', className: 'bg-[#0079BE] text-white' },
  jcb: { label: 'JCB', className: 'bg-[#0E4C96] text-white' },
  unionpay: { label: 'UP', className: 'bg-[#005BAC] text-white' },
};

interface CardBrandMarkProps {
  brand: string;
  className?: string;
}

export function CardBrandMark({ brand, className }: CardBrandMarkProps) {
  const style = BRAND_STYLES[brand?.toLowerCase()];

  if (!style) {
    return (
      <div
        className={cn(
          'h-8 w-12 rounded-md bg-gray-100 flex items-center justify-center flex-shrink-0',
          className,
        )}
      >
        <CreditCard className="h-4 w-4 text-gray-500" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'h-8 w-12 rounded-md flex items-center justify-center flex-shrink-0 text-[10px] font-bold',
        style.className,
        className,
      )}
      aria-hidden="true"
    >
      {style.label}
    </div>
  );
}
